export default __webpack_public_path__ + "static/media/project_default.b7227191.jpg";